const API_URL = process.env.REACT_APP_API_URL || (process.env.NODE_ENV === 'production' ? '/api' : 'http://localhost:5000/api');

// Get token from localStorage (only used for Admin now)
const getToken = () => localStorage.getItem('adminToken');

// Helper function for API calls
const apiCall = async (endpoint, options = {}) => {
  const token = getToken();
  
  const headers = {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...options.headers,
  };

  const response = await fetch(`${API_URL}${endpoint}`, {
    ...options,
    headers,
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.error || 'Something went wrong');
  }

  return data;
};

// Admin API
export const adminAPI = {
  login: (email, password) =>
    apiCall('/admin/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  getStats: () => apiCall('/admin/stats'),

  getKeys: async () => {
    const data = await apiCall('/admin/keys');
    if (data.keys) {
      data.keys = data.keys.map(k => ({ ...k, key_value: atob(k.key_value) }));
    }
    return data;
  },
  
  addKey: (protocol_type, key_value) =>
    apiCall('/admin/keys', {
      method: 'POST',
      body: JSON.stringify({ protocol_type, key_value: btoa(key_value) }),
    }),

  deleteKey: (id) =>
    apiCall(`/admin/keys/${id}`, { method: 'DELETE' }),

  resetKey: (id) =>
    apiCall(`/admin/keys/${id}/reset`, { method: 'POST' }),

  getUsers: () => apiCall('/admin/users'),

  deleteUser: (id) =>
    apiCall(`/admin/users/${id}`, { method: 'DELETE' }),

  getAnnouncement: () => apiCall('/announcement'),

  saveAnnouncement: (text) =>
    apiCall('/admin/announcement', {
      method: 'POST',
      body: JSON.stringify({ text }),
    }),

  changePassword: (currentPassword, newPassword) =>
    apiCall('/admin/change-password', {
      method: 'POST',
      body: JSON.stringify({ currentPassword, newPassword }),
    }),
};

// Keys API (No Auth required, IP based)
export const keysAPI = {
  getStats: () => apiCall('/keys/stats'),

  getMyKey: async () => {
    const data = await apiCall('/keys/my-key');
    if (data.hasKeys && data.keys) {
      data.keys = data.keys.map(k => ({ ...k, key_value: atob(k.key_value) }));
    }
    return data;
  },

  claimKey: async (protocol_type) => {
    const data = await apiCall('/keys/claim', { 
      method: 'POST',
      body: JSON.stringify({ protocol_type }),
    });
    if (data.key) {
      data.key.key_value = atob(data.key.key_value);
    }
    return data;
  },
};

// Tutorials API (No Auth required)
export const tutorialsAPI = {
  getAll: () => apiCall('/tutorials'),
  getByProtocol: (protocol) => apiCall(`/tutorials/${protocol}`),
};

// Messages API
export const messagesAPI = {
  send: (message) =>
    apiCall('/messages', {
      method: 'POST',
      body: JSON.stringify({ message }),
    }),

  // Admin only
  getAll: () => apiCall('/admin/messages'),
  markRead: (id) => apiCall(`/admin/messages/${id}/read`, { method: 'PATCH' }),
  delete: (id) => apiCall(`/admin/messages/${id}`, { method: 'DELETE' }),
};

export default API_URL;
